import { render, staticRenderFns } from "./marketplaces.vue?vue&type=template&id=19109277&scoped=true&"
import script from "./marketplaces.vue?vue&type=script&lang=js&"
export * from "./marketplaces.vue?vue&type=script&lang=js&"
import style0 from "./marketplaces.vue?vue&type=style&index=0&id=19109277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19109277",
  null
  
)

export default component.exports